module.exports = __webpack_public_path__ + "img/8-2.53d932b3.jpg";